const PROPERTY_NAME = {

  id: "property_name",
  type: "text",
  props: {
    className: "property_name"
  }

}

const COL_PROPERTY_NAME = {

  id: "col_property_name",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 12,
  },
  children: [PROPERTY_NAME]

}

export { PROPERTY_NAME, COL_PROPERTY_NAME };
